// components/ShipmentSort.tsx
import { Dropdown, Flex } from 'antd';
import { CustomTitle } from '@/components';
import { UpArrowIcon, DownArrowIcon } from '@/assets/icons/icons';

type SortMenuItem = {
  key: string;
  label: string;
  onClick: () => void;
};

type SortMenu = {
  items: SortMenuItem[];
};

type Props = {
  sortMenu: SortMenu;
  selectedSortLabel: string;
  sortKey: string;
  sortOrder: 'ascending' | 'descending';
  onToggleOrder: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const ShipmentSort: React.FC<Props> = ({
  sortMenu,
  selectedSortLabel,
  sortKey,
  sortOrder,
  onToggleOrder,
}) => {
  const styledMenu = {
    items: sortMenu.items.map((item) => ({
      ...item,
      label: (
        <span style={{ fontWeight: item.key === sortKey ? 700 : 400 }}>
          {item.label}
        </span>
      ),
    })),
  };

  return (
    <Dropdown menu={styledMenu} trigger={['click']}>
      <Flex gap={2} align='center' className='cursor-pointer shipment-sort'>
        {/* Above 1200px: full "Sort by: [selected label]" */}
        <span className='sort-full-text'>
          <Flex gap={6} align='center'>
            <CustomTitle
              whiteSpace='nowrap'
              marginBottom={0}
              text='Sort by:'
              fontWeight='400'
              fontSize='12px'
            />
            <CustomTitle
              marginTop={0}
              text={selectedSortLabel}
              fontWeight='600'
              fontSize='12px'
              whiteSpace='nowrap'
              marginBottom={0}
            />
          </Flex>
        </span>

        {/* Below 1200px: compact "Sort" + icon */}
        <span className='sort-compact-text'>
          <Flex gap={4} align='center'>
            <CustomTitle
              whiteSpace='nowrap'
              marginBottom={0}
              text='Sort'
              fontWeight='400'
              fontSize='12px'
            />
          </Flex>
        </span>

        <button
          type='button'
          className='sort-arrow-wrapper shipment-arrow'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onToggleOrder(e);
          }}
          style={{ padding: 0 }}
        >
          {sortOrder === 'ascending' ? (
            <UpArrowIcon
              size={16}
              color='var(--text-primary)'
              style={{ marginRight: 0 }}
            />
          ) : (
            <DownArrowIcon
              size={16}
              color='var(--text-primary)'
              style={{ marginRight: 0 }}
            />
          )}
        </button>
      </Flex>
    </Dropdown>
  );
};

export default ShipmentSort;
